import React, { useEffect, useState } from "react";
import axios from "axios";
import { decrpt } from "../../component/encryption";
import Cookies from "js-cookie";
import { AiFillEdit, AiFillDelete, AiOutlinePlus } from "react-icons/ai";
import { FormControl, Modal, Form, Button, Badge } from "react-bootstrap";
import Loader from "../../component/loader";

function SettingBanner() {  
  const [loader, setLoader] = useState(false);
  const [bannerList, setBannerList] = useState([]);
  const [show, setShow] = useState(false);
  const [editShow, setEditShow] = useState(false);
  const [error, setError] = useState(null);

  // For Add
  const [addBanner, setAddBanner] = useState({
    heading: '',
    image: null,
    type: 2
  });
  const [newBannerPreview, setNewBannerPreview] = useState('');

  // For Edit
  const [bannerSelected, setBannerSelected] = useState({
    id: '',
    image: null,
    heading: '',
    type: 2
  });
  const [bannerPreview, setBannerPreview] = useState('');

  const bannerListFetch = async () => {
    setLoader(true);
    try {
      let token = decrpt(Cookies.get('s_l'));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      // Query for banners (type: 2) without restricting status
      const response = await axios.post(`/admin/slider/list`, { type: 2 });
      if (response.data && response.data.data) {
        let items = response.data.data;
        // If type is present on the items, ensure we only show banners (type == 2)
        if (items.some(it => it.type !== undefined)) {
          items = items.filter(it => it.type == 2);
        } else {
          // If the live server has not yet been updated to return 'type',
          // all existing items in the database are sliders (type: 1), so banner list should be empty
          items = [];
        }
        setBannerList(items);
      }
    } catch (err) {
      console.error('Error fetching banner list:', err);
    } finally {
      setLoader(false);
    }
  };

  const handlePreviewAdd = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setNewBannerPreview(URL.createObjectURL(file));
      setAddBanner(prev => ({ ...prev, image: file }));
    }
  };

  const handlePreviewEdit = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setBannerPreview(URL.createObjectURL(file));
      setBannerSelected(prev => ({ ...prev, image: file }));
    }
  };

  const bannerAdd = async (e) => {
    if (e) e.preventDefault();
    if (!addBanner.image) {
      alert("Please select an image file for the banner.");
      return;
    }
    setLoader(true);
    try {
      const formData = new FormData();
      formData.append("image", addBanner.image);
      formData.append("heading", addBanner.heading ? addBanner.heading : '');
      formData.append("type", 2);

      let token = decrpt(Cookies.get('s_l'));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const response = await axios.post(`/admin/slider/save`, formData);

      if (response.data && response.data.success) {
        setShow(false);
        setAddBanner({ heading: '', image: null, type: 2 });
        setNewBannerPreview('');
        bannerListFetch();
      }
    } catch (err) {
      console.error('Error adding banner:', err);
      alert(err.response?.data?.message || 'Failed to add banner');
    } finally {
      setLoader(false);
    }
  };

  const handleEdit = (item) => {
    setError(null);
    setBannerSelected({
      id: item.id,
      image: null,
      heading: item.heading || '',
      type: 2
    });
    setBannerPreview(item.image || '');
    setEditShow(true);
  };

  const bannerUpdate = async (e) => {
    e.preventDefault();
    setLoader(true);
    setError(null);
    try {
      const formData = new FormData();
      formData.append("id", bannerSelected.id);
      formData.append("heading", bannerSelected.heading ? bannerSelected.heading : '');
      formData.append("type", 2);

      // ONLY append image if a new File was selected!
      if (bannerSelected.image instanceof File) {
        formData.append("image", bannerSelected.image);
      }

      let token = decrpt(Cookies.get('s_l'));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const response = await axios.post(`/admin/slider/save`, formData);

      if (response.data && response.data.success) {
        setEditShow(false);
        bannerListFetch();
      }
    } catch (err) {
      console.error('Error updating banner:', err);
      if (err.response?.data?.errors) {
        const errObj = err.response.data.errors;
        const msg = Object.values(errObj).flat().join(', ');
        setError(msg);
      } else {
        setError(err.response?.data?.message || 'Failed to update banner');
      }
    } finally {
      setLoader(false);
    }
  };

  const bannerStatusUpdate = async (item) => {
    setLoader(true);
    const newstatus = item.status == 1 ? 2 : 1;
    const data = {
      id: item.id,
      status: newstatus
    };
    try {
      let token = decrpt(Cookies.get('s_l'));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const response = await axios.post(`/admin/slider/status`, data);
      if (response.data && response.data.success) {
        setBannerList(prev => prev.map(s => s.id === item.id ? { ...s, status: newstatus } : s));
      }
    } catch (err) {
      console.error('Error updating banner status:', err);
      alert('Failed to update status. Please try again.');
    } finally {
      setLoader(false);
    }
  };

  const bannerDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this banner? This action cannot be undone.")) {
      return;
    }
    setLoader(true);
    try {
      let token = decrpt(Cookies.get('s_l'));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const response = await axios.post(`/admin/slider/delete`, { id });
      if (response.data && response.data.success) {
        setBannerList(prev => prev.filter(s => s.id !== id));
      } else {
        alert(response.data?.message || 'Could not delete banner');
      }
    } catch (err) {
      console.error('Error deleting banner:', err);
      alert(err.response?.data?.message || 'Failed to delete banner. Ensure backend endpoint is deployed.');
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    bannerListFetch();
  }, []);

  return (
    <div className="main-content">
      {loader ? (
        <Loader />
      ) : (
        <div className="section">
          <div className="card p-3 shadow-sm border-0 rounded-3">
            <div className="card-title d-flex align-items-center justify-content-between pb-3 mb-3 border-bottom flex-wrap gap-2">
              <div>
                <h5 className="mb-0 fw-bold">Website Banner</h5>
                <small className="text-muted">Total: {bannerList?.length || 0} banner{bannerList?.length === 1 ? '' : 's'}</small>
              </div>
              <button 
                onClick={() => {
                  setAddBanner({ heading: '', image: null, type: 2 });
                  setNewBannerPreview('');
                  setShow(true);
                }} 
                className="btn btn-sm btn-primary d-flex align-items-center gap-1 text-white fw-semibold"
              >
                <AiOutlinePlus size={16} /> Add New Banner
              </button>
            </div>

            <div className="row g-3">
              {bannerList && bannerList.length > 0 ? (
                bannerList.map((item, index) => {
                  const isActive = item.status == 1;
                  return (
                    <div key={index} className="col-lg-3 col-md-4 col-sm-6">
                      <div className="card h-100 border shadow-sm rounded-3 overflow-hidden">
                        <div style={{ position: 'relative', height: 160, backgroundColor: '#f3f4f6' }}>
                          <img 
                            src={item.image} 
                            alt={item.heading || 'Banner'} 
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            onError={(e) => { e.target.src = '/folder.png'; }}
                          />
                          <div style={{ position: 'absolute', top: 8, right: 8 }}>
                            {isActive ? (
                              <Badge bg="success" className="px-2 py-1 shadow-sm">Active</Badge>
                            ) : (
                              <Badge bg="secondary" className="px-2 py-1 shadow-sm">Inactive</Badge>
                            )}
                          </div>
                        </div>

                        <div className="card-body p-3 d-flex flex-column justify-content-between">
                          <div>
                            <p className="fw-semibold text-dark mb-2 text-truncate" title={item.heading || 'No Caption'}>
                              {item.heading || <span className="text-muted fst-italic">No Caption</span>}
                            </p>
                          </div>

                          <div className="d-flex align-items-center justify-content-between gap-1 pt-2 border-top mt-2">
                            {isActive ? (
                              <button 
                                className="btn btn-xs btn-outline-danger" 
                                onClick={() => bannerStatusUpdate(item)}
                                title="Click to Disable"
                              >
                                Disable
                              </button>
                            ) : (
                              <button 
                                className="btn btn-xs btn-outline-success" 
                                onClick={() => bannerStatusUpdate(item)}
                                title="Click to Enable"
                              >
                                Enable
                              </button>
                            )}

                            <div className="d-flex gap-1">
                              <button 
                                className="btn btn-xs btn-primary text-white d-flex align-items-center gap-1" 
                                onClick={() => handleEdit(item)}
                                title="Edit Banner"
                              >
                                <AiFillEdit /> Edit
                              </button>
                              <button 
                                className="btn btn-xs btn-danger text-white d-flex align-items-center gap-1"
                                onClick={() => bannerDelete(item.id)}
                                title="Delete Banner"
                              >
                                <AiFillDelete /> Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="col-12 py-5 text-center text-muted">
                  <p className="mb-0">No banners found. Click "Add New Banner" to add one.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Add Banner Modal */}
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="h6 fw-bold">Add New Banner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={bannerAdd}>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-semibold">Banner Caption / Heading</Form.Label>
              <FormControl 
                type="text" 
                value={addBanner.heading} 
                onChange={e => setAddBanner({ ...addBanner, heading: e.target.value })} 
                placeholder="Type banner caption..." 
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="small fw-semibold">Upload Image <span className="text-danger">*</span></Form.Label>
              <Form.Control type="file" accept="image/*" onChange={handlePreviewAdd} required />
            </Form.Group>

            <div className="d-flex w-100 align-items-center justify-content-between pt-2 border-top">
              <div style={{ width: 100, height: 60, borderRadius: 6, overflow: 'hidden', border: '1px solid #ddd' }}>
                <img 
                  src={newBannerPreview || '/folder.png'} 
                  alt="Preview" 
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
              <div className="d-flex gap-2">
                <Button variant="secondary" size="sm" onClick={() => setShow(false)}>Cancel</Button>
                <Button variant="primary" size="sm" type="submit">Add Banner</Button>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Edit Banner Modal */}
      <Modal show={editShow} onHide={() => setEditShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="h6 fw-bold">Edit Banner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <div className="alert alert-danger py-2 small">{error}</div>}
          <Form onSubmit={bannerUpdate}>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-semibold">Banner Caption / Heading</Form.Label>
              <FormControl 
                type="text" 
                value={bannerSelected.heading} 
                onChange={e => setBannerSelected({ ...bannerSelected, heading: e.target.value })} 
                placeholder="Type banner caption..." 
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="small fw-semibold">Replace Image (Optional)</Form.Label>
              <Form.Control type="file" accept="image/*" onChange={handlePreviewEdit} />
              <small className="text-muted d-block mt-1">Leave empty to keep existing image.</small>
            </Form.Group>

            <div className="d-flex w-100 align-items-center justify-content-between pt-2 border-top">
              <div style={{ width: 100, height: 60, borderRadius: 6, overflow: 'hidden', border: '1px solid #ddd' }}>
                <img 
                  src={bannerPreview || '/folder.png'} 
                  alt="Preview" 
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
              <div className="d-flex gap-2">
                <Button variant="secondary" size="sm" onClick={() => setEditShow(false)}>Cancel</Button>
                <Button variant="primary" size="sm" type="submit">Save Changes</Button>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default SettingBanner;
